import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ChartElementSize, ChartValueInterface } from '../interfaces';

@Component({
  standalone: false,
  selector: 'campus-grid-diagram',
  templateUrl: './grid-diagram.component.html',
  styleUrls: ['./grid-diagram.component.scss'],
})
export class GridDiagramComponent {
  @Input() values: ChartValueInterface[];
  @Input() size?: ChartElementSize = 'small';
  @Input() rows? = 5;
  @Input() showTooltip? = true;

  @Output() clickChart = new EventEmitter<ChartValueInterface>();

  @HostBinding('class')
  get hostClasses(): string {
    return ['ui-grid-diagram', `ui-grid-diagram--${this.size}`, `ui-grid-diagram--rows-${this.rows}`].join(' ');
  }

  public chartClicked(value: ChartValueInterface): void {
    this.clickChart.emit(value);
  }
}
